module.exports = __webpack_public_path__ + "static/media/volunteer2.ce5af112.jpg";